
    <div class="device-type-widget" *ngIf="!entity">
      <widget-spinner></widget-spinner>
    </div>
    <ng-container *ngIf="entity">
      <ng-container [ngSwitch]="layout">
        <div class="device-type-widget" *ngSwitchCase="'mini'">
          [Device Type.mini]
        </div>
        <div class="device-type-widget" *ngSwitchCase="'brief'">
          <div class="card border-info" *ngIf="entity">
            <div class="card-header bg-info m-0 p-1">
              <strong>Device Types:</strong>
              <a
                class="text-dark"
                [routerLink]="[
                  '/portal/device/definitions/' + entity.identifier
                ]"
              >
                {{ entity.internalName }}</a
              >
              <div class="card-header-actions">
                <span
                  ><i
                    *ngIf="collapsible"
                    (click)="expandCard = !expandCard"
                    class="fa fa-sm pr-2"
                    [ngClass]="{
                      'fa-chevron-down': !expandCard,
                      'fa-chevron-up': expandCard
                    }"
                  >
                  </i
                ></span>
              </div>
            </div>
            <div class="card-body p-1">
              <!-- Device Image -->
              <div class="row mb-2">
                <div class="col-12 text-center" *ngIf="entity.image">
                  <img
                    [src]="entity.image"
                    style="max-width: 90%; max-height: 10vh"
                    alt="{{ entity.name }}"
                  />
                </div>
              </div>

              <div *ngIf="expandCard">
                <!-- Name -->
                <div class="row mb-1">
                  <div class="col-12"><b>Name:</b></div>
                  <div class="col-12">{{ entity.name }}</div>
                </div>

                <!-- Internal Name -->
                <div class="row mb-1">
                  <div class="col-12"><b>Internal:</b></div>
                  <div class="col-12">{{ entity.internalName }}</div>
                </div>

                <!-- Definition -->
                <div class="row mb-1">
                  <div class="col-12"><b>Definition:</b></div>
                  <div class="col-12">
                    <a
                      [routerLink]="[
                        '/portal/device/definitions/' + entity.identifier
                      ]"
                      >{{ entity.identifier }}</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ================================================= -->
        <!-- Standard                                          -->
        <!-- ================================================= -->
        <div class="device-type-widget" *ngSwitchCase="'standard'">
          <ng-container *ngTemplateOutlet="standard"></ng-container>
        </div>

        <!-- ================================================= -->
        <!-- shadowbox                                          -->
        <!-- ================================================= -->
        <div class="device-type-widget" *ngSwitchCase="'shadowbox'">
          <ng-container *ngTemplateOutlet="standard"></ng-container>
        </div>

        <!-- ================================================= -->
        <!-- Sidebar                                           -->
        <!-- ================================================= -->
        <div class="device-type-widget" *ngSwitchCase="'sidebar'">
          <ng-container *ngTemplateOutlet="standard"></ng-container>
        </div>

        <!-- ================================================= -->
        <!-- Table                                             -->
        <!-- ================================================= -->

        <ng-container *ngSwitchCase="'nested-header'">
          [Device Field: Nested Headers]
        </ng-container>

        <ng-container *ngSwitchCase="'table'">
          <div
            class="device-type-widget row"
            *ngIf="options['index'] == 0 && options['header']"
          >
            <ng-container *ngFor="let column of options.columns">
              <ng-container [ngSwitch]="column">
                <div class="col-2  div-table-th" *ngSwitchCase="'identifier'">
                  Id
                </div>
                <div class="col-2  div-table-th" *ngSwitchCase="'internal'">
                  Internal Name
                </div>
                <div class="col-2  div-table-th" *ngSwitchCase="'name'">
                  Name
                </div>
                <div class="col-2  div-table-th" *ngSwitchCase="'handle'">
                  Handle
                </div>
                <div class="col-2  div-table-th" *ngSwitchCase="'description'">
                  Description
                </div>
                <div class="col-2  div-table-th" *ngSwitchCase="'actions'">
                  Actions
                </div>

                <!-- <div class="col  div-table-th" *ngSwitchCase="'actions'">Actions</div> -->
              </ng-container>
            </ng-container>
          </div>

          <div class="row">
            <ng-container *ngFor="let column of options.columns">
              <ng-container [ngSwitch]="column">
                <div
                  class="col-2 text-nowrap"
                  [ngClass]="{
                    'div-table-tr-alt': options['index'] % 2,
                    'div-table-tr': !(options['index'] % 2)
                  }"
                  *ngSwitchCase="'identifier'"
                >
                  <a
                    [routerLink]="[
                      '/portal/device/definitions/' + entity.identifier
                    ]"
                    title="{{ entity.identifier }}"
                    ><i class="pr-1 text-dark fa fa-link"></i></a
                  >&nbsp;<a
                    title="{{ entity.identifier }}"
                    [href]="'/portal/device/definitions/' + entity.identifier"
                    (click)="showEditModal(standard, entity, $event)"
                    >{{ entity.identifier }}</a
                  >
                </div>
                <div
                  class="col-2"
                  [ngClass]="{
                    'div-table-tr-alt': options['index'] % 2,
                    'div-table-tr': !(options['index'] % 2)
                  }"
                  *ngSwitchCase="'internal'"
                >
                  {{ entity.internalName }}
                </div>
                <div
                  class="col-2"
                  [ngClass]="{
                    'div-table-tr-alt': options['index'] % 2,
                    'div-table-tr': !(options['index'] % 2)
                  }"
                  *ngSwitchCase="'name'"
                >
                  {{ entity.name }}
                </div>
                <div
                  class="col-2"
                  [ngClass]="{
                    'div-table-tr-alt': options['index'] % 2,
                    'div-table-tr': !(options['index'] % 2)
                  }"
                  *ngSwitchCase="'handle'"
                >
                  {{ entity.handle }}
                </div>
                <div
                  class="col-2"
                  [ngClass]="{
                    'div-table-tr-alt': options['index'] % 2,
                    'div-table-tr': !(options['index'] % 2)
                  }"
                  *ngSwitchCase="'description'"
                >
                  {{ entity.description }}
                </div>
                <div
                  class="col-2"
                  [ngClass]="{
                    'div-table-tr-alt': options['index'] % 2,
                    'div-table-tr': !(options['index'] % 2)
                  }"
                  *ngSwitchCase="'actions'"
                >
                  <button
                    *ngIf="device_type_admin"
                    (click)="
                      showCloneModal(deviceTypeListModal, entity, $event)
                    "
                    class="button btn-primary"
                  >
                    Clone
                  </button>
                </div>

                <!-- <div class="col" [ngClass]="{'div-table-tr-alt': (options['index'] % 2), 'div-table-tr': !(options['index'] % 2) }"  *ngSwitchCase="'actions'">
              [actions]
            </div> -->
              </ng-container>
            </ng-container>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="'nested-table'">
          [Device Field: Nested Table]
        </ng-container>

        <div class="device-entity-widget" *ngSwitchDefault>
          <ng-container *ngTemplateOutlet="standard"></ng-container>
        </div>
      </ng-container>
    </ng-container>

    <ng-template #standard>
      <div
        class="modal-header d-flex justify-content-between align-items-center"
      >
        <h4 class="modal-title m-0">{{ currentModal?.title }}</h4>
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="deviceTypeListModalRef.hide()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div
        *ngIf="currentModal?.errorMsg"
        class="alert alert-danger m-2 mb-3 py-2"
      >
        {{ currentModal?.errorMsg }}
      </div>

      <!-- Not Loaded -->
      <div class="card mb-3" *ngIf="!entity">
        <div
          class="card-header d-flex justify-content-start align-items-center"
        >
          <strong>Device Type:</strong> Loading
        </div>
        <div class="card-body text-center py-4">
          <widget-spinner></widget-spinner>
        </div>
      </div>

      <!-- Loaded -->
      <div class="card border-info mb-3" *ngIf="entity">
        <div
          class="card-header bg-info text-white d-flex justify-content-start align-items-center"
        >
          <strong>Device Type:</strong> {{ "  " }} {{ entity.internalName }}
        </div>

        <div class="card-body" *ngIf="expandCard">
          <!-- Device Image -->
          <div class="row mb-4">
            <div class="col-12 text-center" *ngIf="entity.image">
              <img
                [src]="entity.image"
                class="img-fluid"
                style="max-height: 20vh"
                alt="{{ entity.name }}"
              />
            </div>
            <div *ngIf="options?.edit" class="col-12 text-center mt-2">
              <input
                type="text"
                class="form-control form-control-sm"
                [(ngModel)]="entity.image"
                (ngModelChange)="updateType(entity)"
                placeholder="Image URL"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="card mb-3">
                <div class="card-header bg-secondary text-white font-weight-bold">Details</div>
                <div class="card-body">
                  <!-- Definition @todo link-->
                  <div class="row mb-2">
                    <div class="col-md-3 col-4 font-weight-bold">Definition:</div>
                    <div class="col-md-9 col-8">
                      <a
                        routerLinkActive="active"
                        [routerLink]="[
                          '/portal/device/definitions/' + entity.identifier
                        ]"
                        class="text-decoration-none"
                      >
                        {{ entity.identifier }}
                      </a>
                    </div>
                  </div>

                  <!-- Name -->
                  <div class="row mb-2">
                    <div class="col-md-3 col-4 font-weight-bold font-weight-bold">Name:</div>
                    <div class="col-md-9 col-8" *ngIf="!options?.edit">
                      {{ entity.name }}
                    </div>
                    <div class="col-md-9 col-8" *ngIf="options?.edit">
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        [(ngModel)]="entity.name"
                        (ngModelChange)="updateType(entity)"
                      />
                    </div>
                  </div>

                  <!-- Internal Name -->
                  <div class="row mb-2">
                    <div class="col-md-3 col-4 font-weight-bold font-weight-bold">Internal:</div>
                    <div class="col-md-9 col-8" *ngIf="!options?.edit">
                      {{ entity.internalName }}
                    </div>
                    <div class="col-md-9 col-8" *ngIf="options?.edit">
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        [(ngModel)]="entity.internalName"
                        (ngModelChange)="updateType(entity)"
                      />
                    </div>
                  </div>

                  <!-- Description -->
                  <div class="row mb-2">
                    <div class="col-md-3 col-4 font-weight-bold font-weight-bold">Description:</div>
                    <div class="col-md-9 col-8" *ngIf="!options?.edit">
                      {{ entity.description }}
                    </div>
                    <div class="col-md-9 col-8" *ngIf="options?.edit">
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        [(ngModel)]="entity.description"
                        (ngModelChange)="updateType(entity)"
                      />
                    </div>
                  </div>

                  <!-- Default Series -->
                  <div class="row mb-2">
                    <div class="col-md-3 col-4 font-weight-bold font-weight-bold">Default Series:</div>
                    <div class="col-md-9 col-8" *ngIf="!options?.edit">
                      {{ entity.defaultSeries }}
                    </div>
                    <div class="col-md-9 col-8" *ngIf="options?.edit">
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        [(ngModel)]="entity.defaultSeries"
                        (ngModelChange)="updateType(entity)"
                      />
                    </div>
                  </div>

                  <!-- Category -->
                  <div class="row">
                    <div class="col-md-3 col-4 font-weight-bold font-weight-bold">Device Category:</div>
                    <div class="col-md-9 col-8" *ngIf="!options?.edit">
                      {{ entity.category?.name }}
                    </div>
                    <div class="col-md-9 col-8" *ngIf="options?.edit">
                      <ng-select
                        *ngIf="this.category.enum"
                        class="ng-select-sm"
                        placeholder="Select Category"
                        [items]="categories"
                        bindLabel="label"
                        bindValue="value"
                        [multiple]="false"
                        handleInputChanges="true"
                        [(ngModel)]="this.category.enum"
                        (ngModelChange)="updateCategory($event)"
                      ></ng-select>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 mb-3">
              <embed-device-attributes
                [entity]="entity"
                [layout]="'card'"
                [options]="
                  options?.attributes || { title: 'Device Type Attributes' }
                "
              ></embed-device-attributes>
            </div>
          </div>

          <!-- Field Entries -->
          <div class="card mb-3">
            <div class="card-header bg-dark text-white">
              <div class="d-flex justify-content-center">
                <b>Field Entries</b>
              </div>
            </div>

            <div class="card-body p-2">
              <div
                class="mb-3 position-relative"
                *ngFor="let field of entity.fieldEntries; let i = index"
              >
                <div class="d-flex">
                  <div class="flex-grow-1">
                    <embed-device-type-field-entry
                      [entity]="field"
                      [options]="options"
                      [layout]="layout"
                    ></embed-device-type-field-entry>
                  </div>
                  <i
                    *ngIf="entity.fieldEntries.length > 1"
                    class="fa fa-trash text-danger ms-2 align-self-start"
                    (click)="removeField(i)"
                    style="cursor: pointer;"
                  ></i>
                </div>
              </div>
            </div>
          </div>
          <!-- End of Field Entries -->
        </div>
      </div>

      <div class="modal-footer">
        <button
          *ngIf="currentModal?.cancelMsg"
          type="button"
          class="btn btn-outline-secondary"
          (click)="currentModal?.cancel()"
          data-dismiss="modal"
        >
          {{ currentModal?.cancelMsg }}
        </button>
        <button
          *ngIf="currentModal?.deleteMsg"
          type="button"
          class="btn btn-outline-warning"
          (click)="currentModal?.delete()"
          data-dismiss="modal"
        >
          {{ currentModal?.deleteMsg }}
        </button>
        <button
          *ngIf="currentModal?.revertMsg"
          type="button"
          class="btn btn-outline-warning"
          (click)="currentModal?.revert()"
          data-dismiss="modal"
        >
          {{ currentModal?.revertMsg }}
        </button>
        <button
          *ngIf="currentModal?.confirmMsg"
          type="button"
          class="btn btn-primary"
          (click)="currentModal?.confirm()"
        >
          {{ currentModal?.confirmMsg }}
        </button>
      </div>
    </ng-template>

    <ng-template #deviceTypeListModal>
      <div class="modal-header">
        <h4 class="modal-title pull-left">{{ currentModal?.title }}</h4>
        <button
          type="button"
          class="close pull-right"
          aria-label="Close"
          (click)="deviceTypeListModalRef.hide()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <widget-spinner *ngIf="currentModal?.processing"></widget-spinner>
        <div class="row" *ngIf="!currentModal?.processing">
          <div class="col-12">{{ currentModal?.msg }}</div>
          <div class="col-12">
            <div class="row">
              <div class="col-12">
                <div class="card">
                  <div class="card-header">Updated Fields</div>
                  <div class="card-body">
                    <!-- image -->
                    <div class="row mb-1">
                      <div class="col-3"><b>Image:</b></div>
                      <div class="col-9">
                        <input
                          type="text"
                          [(ngModel)]="clone.image"
                          size="64"
                        />
                      </div>
                    </div>

                    <!-- Name -->
                    <div class="row mb-1">
                      <div class="col-3"><b>Name:</b></div>
                      <div class="col-9">
                        <input type="text" [(ngModel)]="clone.name" size="64" />
                      </div>
                    </div>

                    <!-- Internal Name -->
                    <div class="row mb-1">
                      <div class="col-3"><b>Internal:</b></div>
                      <div class="col-9">
                        <input
                          type="text"
                          [(ngModel)]="clone.internalName"
                          size="64"
                        />
                      </div>
                    </div>

                    <!-- Description -->
                    <div class="row mb-3">
                      <div class="col-3"><b>Description:</b></div>
                      <div class="col-9">
                        <input
                          type="text"
                          [(ngModel)]="clone.description"
                          size="64"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <widget
                  [entity]="clone"
                  [layout]="'aside'"
                  [options]="{
                    expand: true,
                    collapsible: false,
                    attributes: { expand: true }
                  }"
                ></widget>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          *ngIf="currentModal?.cancelMsg"
          type="button"
          class="btn btn-secondary"
          (click)="currentModal?.cancel()"
          data-dismiss="modal"
        >
          {{ currentModal?.cancelMsg }}
        </button>
        <button
          *ngIf="currentModal?.deleteMsg"
          type="button"
          class="btn btn-warning"
          (click)="currentModal?.delete()"
          data-dismiss="modal"
        >
          {{ currentModal?.deleteMsg }}
        </button>
        <button
          *ngIf="currentModal?.confirmMsg"
          type="button"
          class="btn btn-danger"
          (click)="currentModal?.confirm()"
        >
          {{ currentModal?.confirmMsg }}
        </button>
      </div>
    </ng-template>

    <!--                                                        -->
    <!--                    Pop-Up Menu                         -->
    <!--                                                        -->
    <ng-template #deviceDefinitionModal>
      <div class="modal-header">
        <h4 class="modal-title pull-left">{{ currentModal?.title }}</h4>
        <button
          type="button"
          class="close pull-right"
          aria-label="Close"
          (click)="deviceDefinitionModalRef.hide()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <widget-spinner *ngIf="currentModal?.processing"></widget-spinner>
        <div class="row" *ngIf="!currentModal?.processing">
          <div class="col-12">
            {{ currentModal?.msg }}
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          *ngIf="currentModal?.cancelMsg"
          type="button"
          class="btn btn-secondary"
          (click)="currentModal?.cancel()"
          data-dismiss="modal"
        >
          {{ currentModal?.cancelMsg }}
        </button>
        <button
          *ngIf="currentModal?.deleteMsg"
          type="button"
          class="btn btn-warning"
          (click)="currentModal?.delete()"
          data-dismiss="modal"
        >
          {{ currentModal?.deleteMsg }}
        </button>
        <button
          *ngIf="currentModal?.confirmMsg"
          type="button"
          class="btn btn-danger"
          (click)="currentModal?.confirm()"
        >
          {{ currentModal?.confirmMsg }}
        </button>
      </div>
    </ng-template>
  